import { type FamilyMemberType, type ApiDataType } from 'types/services/Family'

import cardsInfosHealth from './generateCardInfos/cardsInfosHealth'
import cardsInfoEducation from './generateCardInfos/cardsInfoEducation'
import cardsInfosPregnancy from './generateCardInfos/cardsInfosPregnancy'
import cardsInfosResidence from './generateCardInfos/cardsInfosResidence'
import {
  cardsInfosAllMembersIncome,
  cardsInfosIncome,
} from './generateCardInfos/cardsInfosIncome'
import cardsInfosNutrition from './generateCardInfos/cardsInfosNutrition'

import { type InconsistenciesType } from 'types/services/Inconsistencies'
import { formatMemberDesc } from './familyUtils'

/*
  🔵 Organiza as informações por seções, ou seja, separa as informações
      que estarão presentes em habitação, nutrição, educação, saúde, renda e 
      gravidez.
*/

export function handleCardInfosSections(
  families: ApiDataType[],
  inconsistencies: InconsistenciesType | undefined | null
) {
  const dataInfos = families.map(({ family, base }: ApiDataType) => {
    if (family !== undefined) {
      return {
        base,
        collectDate: family.collectDate.toString(),
        residence: {
          cardsInfos:
            family.residenceInfo !== undefined
              ? cardsInfosResidence(family, inconsistencies)
              : [],
        },
        nutrition: {
          cardsInfos:
            family.nutritionInfo !== undefined
              ? cardsInfosNutrition(family, inconsistencies)
              : [],
        },
        education: {
          members: [
            ...family.members.map((member: FamilyMemberType) => {
              return {
                name: member.name,
                description: formatMemberDesc(member),
                cardsInfos:
                  member.education !== undefined
                    ? cardsInfoEducation(member, base, inconsistencies)
                    : [],
              }
            }),
          ],
        },
        pregnancy: {
          cardsInfos:
            family.pregnantInHome !== undefined
              ? cardsInfosPregnancy(family, inconsistencies)
              : [],
        },
        health: {
          members: [
            ...family.members.map((member: FamilyMemberType) => {
              return {
                name: member.name,
                description: formatMemberDesc(member),
                cardsInfos:
                  member.health !== undefined
                    ? cardsInfosHealth(member, base, inconsistencies)
                    : [],
              }
            }),
          ],
        },
        income: {
          allMembers: {
            name: 'Todos os membros',
            description: 'Informações da família',
            cardsInfos: cardsInfosAllMembersIncome(
              base,
              family,
              inconsistencies
            ),
          },
          members: [
            ...family.members.map((member: FamilyMemberType) => {
              return {
                name: member.name,
                description: formatMemberDesc(member),
                cardsInfos:
                  member.workAndIncome !== undefined
                    ? cardsInfosIncome(member, base)
                    : [],
              }
            }),
          ],
        },
      }
    } else {
      return {
        base,
        family: undefined,
      }
    }
  })
  return dataInfos
}
